export default __webpack_public_path__ + "static/media/etat du sentier.473853d1.png";